import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { EMPTY, Observable, of } from "rxjs";
import { select, Store } from "@ngrx/store";
import { catchError, switchMap, take, tap } from "rxjs/operators";

import { LoadPatients, selectPatients } from "../store";
import { AppState } from "libs/tm-common/src/lib/store/reducers/reducers";
import { PatientModel } from "libs/tm-common/src/lib/models/patient.model";
import { NotificationService } from "libs/tm-common/src/lib/services/notification.service";
import { PatientsService } from "./patients.service";

@Injectable()
export class PatientsResolver {
	constructor(
		private notificationService: NotificationService,
		private patientsService: PatientsService,
		private store: Store<AppState>
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PatientModel[]> {
		return this.store.pipe(
			select(selectPatients),
			take(1),
			switchMap((patients: PatientModel[]) => {
				if (patients?.length === 0) {
					return this.patientsService.getPatients().pipe(
						take(1),
						tap((patients: PatientModel[]) =>
							this.store.dispatch(new LoadPatients({ patients: patients }))
						)
					);
				}
				return of(patients);
			}),
			catchError(() => {
				this.notificationService.showErrorMessage("ResolvePatientsError", "", 5000);
				return EMPTY;
			})
		);
	}
}
